export const SPINNER_STYLES = {
  spinner: "animate-spin text-primary",
  container: "flex items-center justify-center",
} as const;
